import {
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	Output,
} from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { SharedService } from 'src/app/shared/services/shared.service'
import {
	LabelEnum,
	productPromoCodeType,
	ActivationEnum,
} from '../../models/product-promo-code.enum'
import { productPromoCodeFilterModel } from '../../models/product-promo-code.model'

@Component({
	selector: 'app-product-promo-code-filter',
	templateUrl: './product-promo-code-filter.component.html',
	styleUrl: './product-promo-code-filter.component.scss',
})
export class ProductPromoCodeFilterComponent {
	@Output() emitFilter = new EventEmitter()
	@Output() emitFilterCount = new EventEmitter()
	@Input() filterData: productPromoCodeFilterModel = {
		paging: { pageNumber: 1, pageSize: 10 },
		SearchText: '',
		ActiveTab: 0,
		countryId: 224,
		StartDate: '',
		EndDate: '',
		ActivationStatus: [],
		Amount: 0,
		promocodeTypes: [],
		LabelStatus: [],
		ClientUsage: null,
	}
	subscription = new Subscription()
	filterForm: FormGroup = new FormGroup({})
	labelingEnum = this.SharedService.returnEnumArray(LabelEnum)
	promoCodeTypesEnum = this.SharedService.returnEnumArray(productPromoCodeType)
	activationEnum = this.SharedService.returnEnumArray(ActivationEnum)
	filterCount = 0

	constructor(
		public translate: TranslateService,
		private SharedService: SharedService,
		private cd: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.initForm()
		this.changesSubscribe()
	}
	changesSubscribe() {
		this.filterForm.valueChanges.subscribe((val) => {
			this.filterCount = 0

			for (let value in val) {
				if (
					(this.getController(value).value ||
						this.getController(value).value == 0) &&
					this.getController(value).value != false
				) {
					this.filterCount += 1
				}
			}
		})
	}
	ngOnChanges() {
		this.initForm()
		this.changesSubscribe()
		this.filterForm.patchValue(this.filterData)
	}
	initForm() {
		this.filterForm = new FormGroup({
			startDate: new FormControl(this.filterData?.StartDate),
			endDate: new FormControl(this.filterData?.EndDate),
			clientUsage: new FormControl(this.filterData?.ClientUsage, [
				Validators.min(1),
			]),
			Amount: new FormControl(this.filterData?.Amount, [Validators.min(1)]),
			ActivationStatus: new FormControl(this.filterData.ActivationStatus || []),
			promocodeTypes: new FormControl(this.filterData?.promocodeTypes || []),
			LabelStatus: new FormControl(this.filterData.LabelStatus || []),
		})
	}

	resetFilter() {
		this.filterForm.reset()
		this.filterData = {
			...this.filterData,
			...this.filterForm.getRawValue(),
		}
		this.filterCount = 0
		this.emitFilter.emit(this.filterData)
		this.emitFilterCount.emit(this.filterCount)
	}

	getController(controlName: string) {
		return (this.filterForm as FormGroup).controls[controlName] as FormControl
	}
	CheckboxChange(event: any, controller: string) {
		const control = this.getController(controller)
		let currentValue = control.value || []

		if (event?.checked) {
			if (!Array.isArray(currentValue)) {
				currentValue = []
			}

			control.setValue([...currentValue, event.source.value])
		} else {
			const newValue = currentValue.filter(
				(item: any) => item !== event.source.value
			)
			control.setValue(newValue)
		}
	}
	submit() {
		let filter = { ...this.filterData, ...this.filterForm.getRawValue() }

		filter.startDate
			? (filter.startDate = new Date(
					this.getController('startDate')?.value
			  ).toISOString())
			: null
		filter.endDate
			? (filter.endDate = new Date(
					this.getController('endDate')?.value
			  ).toISOString())
			: null
		filter.paging = { pageNumber: 1, pageSize: 10 }

		this.emitFilter.emit(filter)
		this.emitFilterCount.emit(this.filterCount)
	}
}
